var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11439 3.4478C1.33334 4.22885 1.33334 5.48592 1.33334 8.00008C1.33334 10.5142 1.33334 11.7713 2.11439 12.5524C2.89544 13.3334 4.15252 13.3334 6.66668 13.3334H9.33334C11.8475 13.3334 13.1046 13.3334 13.8856 12.5524C14.6667 11.7713 14.6667 10.5142 14.6667 8.00008C14.6667 5.48592 14.6667 4.22885 13.8856 3.4478C13.1046 2.66675 11.8475 2.66675 9.33334 2.66675H6.66668C4.15252 2.66675 2.89544 2.66675 2.11439 3.4478ZM12.3841 5.01332C12.5609 5.22546 12.5322 5.54074 12.3201 5.71753L10.8558 6.93779C10.2649 7.43023 9.78593 7.82936 9.36323 8.10123C8.92289 8.38443 8.49406 8.56333 8.00001 8.56333C7.50596 8.56333 7.07713 8.38443 6.6368 8.10123C6.21409 7.82936 5.73515 7.43024 5.14425 6.9378L3.67992 5.71753C3.46778 5.54074 3.43912 5.22546 3.6159 5.01332C3.79268 4.80118 4.10796 4.77252 4.3201 4.9493L5.75937 6.14869C6.38134 6.667 6.81316 7.02569 7.17773 7.26017C7.53064 7.48714 7.76996 7.56333 8.00001 7.56333C8.23006 7.56333 8.46938 7.48714 8.82229 7.26017C9.18686 7.02569 9.61868 6.667 10.2407 6.14869L11.6799 4.9493C11.8921 4.77252 12.2073 4.80118 12.3841 5.01332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWhite);
export default __webpack_public_path__ + "static/media/message-white.4d9fc2b07cc810a689f9404a78eae570.svg";
export { ForwardRef as ReactComponent };